// API Data
export interface IDepartmentData {
  id?: number;
  code: string;
  name: string;
  production?: boolean;
}

export interface IDepartmentFieldErrorData {
  code?: string[];
  name?: string[];
  production?: string[];
}

// Business Logic Interface
export interface IDepartment extends IDepartmentData {
  validate(): boolean;

  /**
   * @property
   * getter for departmentInfo
   */
  departmentInfo: string;
}

export interface IDepartmentFieldError extends IDepartmentFieldErrorData {
  clearErrors(): void;
}

// Constants - Used for validation
export const DEPARTMENT_MAX_CODE_LENGTH = 3;
export const DEPARTMENT_MAX_NAME_LENGTH = 24;
